import OtpInput from "react-otp-input";
import ParagraphText from "../ParagraphText";
import { Box } from "@material-ui/core";
import { useEffect, useState } from "react";
import "./styles.css";

const UBOTPInput = ({
  className = "",
  label,
  numInputs = 4,
  containerStyle = {},
  value,
  onChangeQuery = () => {},
  onComplete = () => {},
  isInputNum = true,
  placeholder,
  shouldAutoFocus = false,
  helperText = "",
  invalid,
  disabled,
  isInputSecure = true,
  required,
  id = "",
}) => {
  const [errorDismissed, setErrorDismissed] = useState(false);

  useEffect(() => {
    if (invalid) setErrorDismissed(false);
  }, [invalid]);

  const handleChange = (val) => {
    if (invalid) setErrorDismissed(true);
    onChangeQuery(val);
  };

  const showError = invalid && !errorDismissed;

  return (
    <Box className={`UBOTPInputWrapper ${className}`}>
      {!!label && (
        <ParagraphText className={"fontSize14 newFontColor labelText"}>
          {label}
          {required && <span className="foundationErrorRed">*</span>}
        </ParagraphText>
      )}
      <OtpInput
        data-testid={id}
        id={id}
        placeholder={placeholder}
        numInputs={numInputs}
        containerStyle={{
          width: "100%",
          gap: "16px",
          marginTop: "4px",
          ...containerStyle,
        }}
        className={`CreatePinInput ${showError ? "error" : ""}`}
        value={value}
        onChange={handleChange}
        onComplete={onComplete}
        isInputNum={isInputNum}
        shouldAutoFocus={shouldAutoFocus}
        isDisabled={disabled}
        isInputSecure={isInputSecure}
        inputStyle={{
          ...(isInputSecure
            ? {
                fontSize: "16px",
                fontWeight: "400",
              }
            : {}),
        }}
      />
      {!!helperText && showError && (
        <ParagraphText className="helperTextMessage" id={`${id}_error`}>
           {helperText}
        </ParagraphText>
      )}
    </Box>
  );
};

export default UBOTPInput;
